/* eslint-disable react/jsx-no-useless-fragment */
import React, { type ReactNode } from 'react';
import { SortableContainer } from 'react-sortable-hoc';

const SortableList = SortableContainer(
  ({ children }: { children: ReactNode }) => <>{children}</>
);

export default SortableList;
